import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box } from '@mui/material';
import CloudIcon from '@mui/icons-material/Cloud';
import GoogleIcon from '@mui/icons-material/Google';
import { useAuth } from '../../contexts/AuthContext';

export const AnonymousUserPrompt = ({ open, onClose }) => {
  const { signInWithGoogle } = useAuth();

  const handleSignIn = async () => {
    onClose();
    await signInWithGoogle();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          textAlign: 'center',
          p: 2
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 1 }}>
        <CloudIcon sx={{ fontSize: 60, color: 'primary.main' }} />
      </Box>
      <DialogTitle sx={{ fontSize: '1.5rem', fontWeight: 600 }}>
        Save Your Plans to the Cloud
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: '1rem', color: 'text.primary' }}>
          Sign in with Google to access your race plans from any device or browser. Your plans will be automatically synced and always available!
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, gap: 2 }}>
        <Button onClick={onClose} variant="outlined" size="large">
          Maybe Later
        </Button>
        <Button 
          onClick={handleSignIn} 
          variant="contained" 
          size="large"
          startIcon={<GoogleIcon />}
          sx={{
            bgcolor: 'accent.main',
            '&:hover': {
              bgcolor: 'accent.dark',
            }
          }}
        >
          Sign In with Google
        </Button>
      </DialogActions>
    </Dialog>
  );
};

